import { render, staticRenderFns } from "./CreditAssignmentExternalRequestForm.vue?vue&type=template&id=28ce7367&"
import script from "./CreditAssignmentExternalRequestForm.vue?vue&type=script&lang=js&"
export * from "./CreditAssignmentExternalRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports